import {FC, memo} from 'react'
import {Col, Pagination, Row} from 'react-bootstrap'
import './PrevNextPaginate.scss'
import useResponsive from '../hooks/useResponsive'
export type CursorPaginateProps = {
  limit: number
  prev: number | null
  next: number | null
  totalData: number
  loadedData: number
  isFetching: boolean

  handleChange: (cursor: number | null, next: boolean) => void
  handleChangSizeData: (limit: number) => void
}

const PrevNextPaginate: FC<CursorPaginateProps> = (props) => {
  const {prev, next, totalData, loadedData, limit, isFetching} = props
  const {isMobile} = useResponsive()
  const {handleChange, handleChangSizeData} = props
  return (
    <div className='abcd prev-next-pagination-container w-100'>
      <select
        onChange={(e: any) => {
          let limit = parseInt(e.target.value)
          handleChangSizeData(limit)
        }}
      >
        <option value={10} selected={limit === 10}>
          10
        </option>
        <option value={20} selected={limit === 20}>
          20
        </option>
        <option value={50} selected={limit === 50}>
          50
        </option>
        <option value={100} selected={limit === 100}>
          100
        </option>
        <option value={250} selected={limit === 250}>
          250
        </option>
        <option value={500} selected={limit === 500}>
          500
        </option>
        <option value={1000} selected={limit === 1000}>
          1000
        </option>
        <option value={5000} selected={limit === 5000}>
          5000
        </option>
        <option value={10000} selected={limit === 10000}>
          10000
        </option>
      </select>
      <div className='data-count'>
        {isFetching
          ? '. . . . .'
          : `Show ${
              loadedData > 0 ? (loadedData > limit ? loadedData - (limit - 1) : 1) : 0
            } - ${loadedData} of ${totalData} data`}
      </div>
      <Row>
        <Col className={`d-flex align-items-center me-3 ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
          {!isFetching && (
            <Pagination>
              <button
                className={`btn btn-sm ${
                  loadedData <= limit ? 'btn-light' : 'btn-primary'
                } mt-4 mt-sm-0 ms-0 ms-sm-3 me-3`}
                onClick={() => {
                  if (loadedData <= limit) {
                    return
                  }
                  handleChange(prev || null, false)
                }}
              >
                Prev
              </button>
              <button
                className={`btn btn-sm ${
                  loadedData >= totalData ? 'btn-light' : 'btn-primary'
                } mt-4 mt-sm-0 ms-0 ms-sm-3 me-3`}
                onClick={() => {
                  if (loadedData >= totalData) {
                    return
                  }
                  handleChange(next || null, true)
                }}
              >
                Next
              </button>
            </Pagination>
          )}
        </Col>
      </Row>
    </div>
  )
}

export default memo(PrevNextPaginate)
